import { ShieldCheck, Sparkles } from "lucide-react";

/**
 * Royal certification badge.
 *
 * - `certified` → full Royal Verified (police cert + trade licence on file)
 * - `entry`     → Entry-level pro (provisional, operating under the 90-day grace)
 *
 * Accepts either a provider object (`{is_certified, verification_level}`) or a
 * raw level string. Falls back to Entry if unclear.
 */
export default function RoyalProClassBadge({ provider, level, size = "md", className = "" }) {
    const lvl = level || (provider?.is_certified ? "royal" : provider?.verification_level) || "entry";
    const isCertified = lvl === "royal" || lvl === "certified";

    const base =
        size === "sm"
            ? "text-[9px] px-2 py-0.5"
            : "text-[10px] px-2.5 py-1";

    if (isCertified) {
        return (
            <span
                data-testid="pro-class-certified"
                className={`inline-flex items-center gap-1 rounded-full border border-[#FFD700]/60 bg-gradient-to-r from-amber-400/15 to-yellow-500/10 text-[#FFD700] uppercase tracking-[0.22em] ${base} ${className}`}
            >
                <ShieldCheck size={size === "sm" ? 9 : 11} />
                Certified Pro
            </span>
        );
    }
    return (
        <span
            data-testid="pro-class-entry"
            className={`inline-flex items-center gap-1 rounded-full border border-emerald-400/40 bg-emerald-500/10 text-emerald-300 uppercase tracking-[0.22em] ${base} ${className}`}
        >
            <Sparkles size={size === "sm" ? 9 : 11} />
            Entry Pro
        </span>
    );
}
